import { render, staticRenderFns } from "./viewUsersModal.vue?vue&type=template&id=66095ea0&scoped=true"
import script from "./viewUsersModal.vue?vue&type=script&lang=js"
export * from "./viewUsersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66095ea0",
  null
  
)

export default component.exports